import { BookmarkOutlineIcon } from './BookmarkOutlineIcon';

/**
 * author: Google
 * id 0EB6BB85-4BE2-4608-BABF-2EF135D420A7
 * name bookmark-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-outline.svg
 * tags
 */
export const TurnedInNotIcon = BookmarkOutlineIcon;
export default TurnedInNotIcon